document.addEventListener('DOMContentLoaded', function() {
  let isAddToCartClick = false;

  // Track add to cart button clicks
  document.addEventListener('click', function(event) {
    const addToCartButton = event.target.closest('[data-product-add-to-cart-button]');
    if (addToCartButton) {
      isAddToCartClick = true;
      setTimeout(() => { isAddToCartClick = false; }, 1000);
    }
  }, true); 

  // Prevent cart drawer from opening on add to cart
  document.addEventListener('cart:refresh', function(event) {
    if (isAddToCartClick && event.detail) {
      event.detail.openMiniCart = false;
    }
  }, true);

  // Handle cart drawer behavior
  const miniCart = document.getElementById('mini-cart');
  if (miniCart) {
    // Handle cart icon clicks
    const cartIcon = document.querySelector('.icon-cart-top');
    if (cartIcon) {
      cartIcon.addEventListener('click', function(event) {
        event.preventDefault();
        miniCart.setAttribute('open', '');
      });
    }

    // Override setAttribute to prevent drawer from opening during add to cart
    const originalSetAttribute = miniCart.setAttribute.bind(miniCart);
    miniCart.setAttribute = function(name, value) {
      if (name === 'open' && isAddToCartClick) {
        return; // Block opening during add to cart
      }
      originalSetAttribute(name, value);
    };
  }
});

// Prevent mini-cart from opening when add to cart is clicked
document.addEventListener('cart:refresh', function(event) {
  if (event.detail) {
    event.detail.openMiniCart = false;
  }
}, true); 